/* Sort dropdown in the store's style.
   The real Shopify <select> stays in the page (hidden) and does the sorting;
   this only draws a nicer list and tells the <select> what was picked. */
if (!customElements.get('chits-sort')) {
  customElements.define(
    'chits-sort',
    class ChitsSort extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const select = this.querySelector('select');
        if (!select) return;
        this.dataset.ready = '1';

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'chits-sort__btn';
        btn.setAttribute('aria-haspopup', 'listbox');
        btn.setAttribute('aria-expanded', 'false');
        const label = document.createElement('span');
        label.className = 'chits-sort__label';
        btn.appendChild(label);
        btn.insertAdjacentHTML(
          'beforeend',
          '<svg class="chits-sort__caret" width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        );

        const list = document.createElement('ul');
        list.className = 'chits-sort__list';
        list.setAttribute('role', 'listbox');

        const draw = () => {
          const current = select.options[select.selectedIndex];
          label.textContent = current ? current.text.trim() : '';
          list.innerHTML = '';
          Array.from(select.options).forEach((option, i) => {
            const li = document.createElement('li');
            li.setAttribute('role', 'option');
            li.setAttribute('aria-selected', i === select.selectedIndex ? 'true' : 'false');
            li.dataset.index = i;
            const text = document.createElement('span');
            text.textContent = option.text.trim();
            const tick = document.createElement('span');
            tick.className = 'chits-sort__tick';
            tick.setAttribute('aria-hidden', 'true');
            tick.textContent = '✓';
            li.append(text, tick);
            list.appendChild(li);
          });
        };

        const setOpen = (open) => {
          this.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        };

        // clicking anywhere on the "Sort by:" box opens / closes the list
        const area = this.closest('.facet-filters__field') || this;
        area.classList.add('chits-sort-area');
        area.addEventListener('click', (e) => {
          if (list.contains(e.target)) return;
          e.preventDefault();
          setOpen(!this.classList.contains('is-open'));
        });

        list.addEventListener('click', (e) => {
          e.stopPropagation();
          const li = e.target.closest('li');
          if (!li) return;
          setOpen(false);
          const index = Number(li.dataset.index);
          if (index === select.selectedIndex) return;
          select.selectedIndex = index;
          draw();
          // hand the choice to Shopify's own filter/sort code
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });

        this._outside = (e) => {
          if (!area.contains(e.target)) setOpen(false);
        };
        document.addEventListener('click', this._outside);
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            setOpen(false);
            btn.focus();
          }
        });
        select.addEventListener('change', draw);

        draw();
        this.append(btn, list);
        this.classList.add('chits-sort--ready');
      }

      disconnectedCallback() {
        if (this._outside) document.removeEventListener('click', this._outside);
      }
    }
  );
}
